import {
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/logisticsAsset/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/cityEnergy/img/1.avif';
import image2 from '@src/assets/images/solution/cityEnergy/img/2.avif';
import image3 from '@src/assets/images/solution/cityEnergy/img/3.avif';
import image4 from '@src/assets/images/solution/cityEnergy/img/4.avif';
import image5 from '@src/assets/images/solution/cityEnergy/img/5.avif';
import image6 from '@src/assets/images/solution/cityEnergy/img/6.avif';

export default {
  type: 'Energy/Environment Solution',

  banner: {
    title: 'Forklift Location Tracking System Trusted Even in Nuclear Power Plants',
    desc: 'Track forklift movements with UWB-based positioning technology and automatically store waste transportation routes, ensuring compliance with regulatory bodies and enhancing asset security.',
  },

  video: {
    title: 'Strong Structures, Weak Signals. ORBRO Breaks the Limit.',
    desc: 'Even in spaces covered with steel plates and ceilings over 10 meters high, ORBRO’s location tracking technology precisely receives signals. It provides data-backed proof of where, when, and by whom assets in the power plant were moved.',
    play: video,
  },

  func: [
    {
      theme: 'Uninterrupted High-Precision Tracking in Extreme Environments',
      title: 'Stable Location Data Even in Metal-Enclosed Structures',
      desc: 'In confined spaces surrounded by metal structures, ORBRO’s tracking system maintains stable performance without signal loss. It provides precise location data within ±30 cm, even in environments where traditional TDoA cannot track.',
      sub1: 'High Accuracy',
      icon1: IconRulerGray,
      sub2: 'Fast Data Integration',
      icon2: IconShareGray,
      image: image1,
    },
    {
      title: 'Installable Even with High Ceilings',
      desc: 'Accurately detects positions even in spaces with ceilings over 10 meters high. Covers large areas with minimal infrastructure, maximizing installation efficiency and operational convenience.',
      sub1: 'Designate High-Risk Assets',
      icon1: IconWarningGray,
      sub2: 'Configure Response Methods',
      icon2: IconBellGray,
      image: image2,
    },
    {
      title: 'Seamless Reception During High-Speed Movement and Complex Routes',
      desc: 'Even when forklifts move quickly or repeatedly operate in narrow areas, every route is recorded accurately without signal loss. Data remains seamless even in indoor reflective environments.',
      sub1: 'High Accuracy',
      icon1: IconRulerGray,
      sub2: 'Fast Data Integration',
      icon2: IconChainLinkGray,
      image: image3,
    },
    {
      theme: 'Precise Algorithms and History-Based Operational Optimization',
      title: 'Advanced TDoA High-Precision Algorithm',
      desc: 'Through six stages of precise processing—time synchronization, clock error correction, and least squares position calculation—accurate positioning is achieved even in complex environments. ORBRO’s unique technology ensures precision and stability optimized for industrial sites.',
      sub1: 'Statistical Data Provided',
      icon1: IconChartBarGray,
      sub2: 'Cloud Data Storage',
      icon2: IconCloudCheckGray,
      image: image4,
    },
    {
      title: 'Filtering for Multipath/NLOS Environments',
      desc: 'Automatically removes distorted data caused by signal reflections or non-line-of-sight (NLOS) conditions to deliver precise, real-path-based locations. Maintains over 98% positioning success rate even in multipath conditions.',
      sub1: 'Statistical Data Provided',
      icon1: IconChartBarGray,
      sub2: 'Cloud Data Storage',
      icon2: IconCloudCheckGray,
      image: image5,
    },
    {
      title: 'Forklift Movement History Timeline Management',
      desc: 'Forklift travel paths and location changes are saved chronologically, allowing analysis of dwell times in specific areas or path deviations.',
      sub1: 'Statistical Data Provided',
      icon1: IconChartBarGray,
      sub2: 'Cloud Data Storage',
      icon2: IconCloudCheckGray,
      image: image6,
    },
  ],

  subfunc: {
    title: 'Various Functions',
    desc: 'Medical waste management must never be taken lightly. Even a small lapse or mistake can lead to serious medical accidents. Therefore, highly precise management and guaranteed safety are essential.<br/>ORBRO provides diverse features to help build safe and efficient medical facilities.',

    data: [
      {
        icon: IconZoneGray,
        title: 'Metal Space Tracking',
        desc: 'Stable in high metal zones.',
      },
      {
        icon: IconRulerGray,
        title: 'ATDoA Precision',
        desc: 'Track fast vehicles ±50cm.',
      },
      {
        icon: IconChainLink,
        title: 'Built-in Multipath/NLOS',
        desc: 'Min error in complex sites.',
      },
      {
        icon: IconDashboard,
        title: 'Live Forklift View',
        desc: 'See forklift on dashboard.',
      },
      {
        icon: IconRoute,
        title: 'Route Timeline',
        desc: 'Save and show move history.',
      },
      {
        icon: IconBinocularsGray,
        title: 'Continuous Tracking',
        desc: 'No gaps for fast vehicles.',
      },
      {
        icon: IconChartRadius,
        title: 'Audit Data Use',
        desc: 'Use logs for compliance.',
      },
      {
        icon: IconWarning,
        title: 'Auto Zone Entry Check',
        desc: 'Detect & log key area entry.',
      },
      {
        icon: IconBell,
        title: 'Stop Alert',
        desc: 'Alert for long idle time.',
      },
      {
        icon: IconRoute,
        title: 'Route Collision Check',
        desc: 'Analyze paths to prevent hits.',
      },
    ],
  },

  system: {
    title: 'System Configuration',
    img: rtlsSystem,
  },

  productTitle: 'Product Configuration',
  product: [{ tag: 'assetPackage' }, { tag: 'workerPackage' }],

  contents: [{ data: 'medicalPatient' }, { data: 'officeAsset' }, { data: 'blogMedical' }, { data: 'blogRTLS' }],
};
